<template>
    <button
        @click.prevent="$emit('selected')"
        class="flex items-center flex-col lg:flex-row lg:p-4 shrink-0 lg:py-3 bg-white border"
        :class="[
            tourClass
        ]"
    >
        <template v-if="type">
            <div
                :style="[type.includes('color') && {backgroundColor: selectedColorHex}]"
                :class="[
                    type.includes('color') ? 'rounded-full border border-black': `menu-item-${(type || 'none')}`,
                    type.includes('individual') && 'rounded-full ml-0.5 mr-3.5',
                    'h-8 w-8 mr-4',
                    { 'border border-gray-300': selected },
                ]">
                <span></span>
            </div>
        </template>
        <div class="flex items-center justify-center w-20 mx-4 lg:mx-0 lg:w-auto uppercase font-bold text-lg">
            <div class="text-base whitespace-pre-wrap lg:text-xl">
                {{title}}
            </div>
        </div>
    </button>
</template>

<style lang="scss">
    @import "../style/variables.scss";

    .menu-item-color {
        background: transparent url(../assets/menu-color@2x.png) no-repeat center/contain;
    }
    .menu-item-side {
        background: transparent url(../assets/menu-side@2x.png) no-repeat center/contain;
    }
    .menu-item-images {
        background: transparent url(../assets/logo.svg) no-repeat center/contain;
    }
    .menu-item-text {
        background: transparent url(../assets/text.svg) no-repeat center/contain;
    }
    .menu-item-monogram {
        background: transparent url(../assets/monogram.svg) no-repeat center/contain;
    }
    .menu-item-group {
        background: transparent url(../assets/group.svg) no-repeat center/contain;
    }
    .menu-item-help {
        background: transparent url(../assets/menu-help@2x.png) no-repeat center/contain;
    }
    .menu-item-side-front {
        background: transparent url(../assets/design-front@2x.png) no-repeat center/contain;
    }
    .menu-item-side-back {
        background: transparent url(../assets/design-back@2x.png) no-repeat center/contain;
    }
    .menu-item-side-front-back {
        background: transparent url(../assets/design-front-back@2x.png) no-repeat center/contain;
    }
    .menu-item-side-both {
        background: transparent url(../assets/design-same@2x.png) no-repeat center/contain;
    }
    .menu-item-individual {
        background: transparent url(../assets/order-single.png) no-repeat center/contain;
    }
    .menu-item-jersey {
        background: transparent url(../assets/jersey.svg) no-repeat center/contain;
    }
</style>

<script>
    import { mapGetters } from 'vuex';

    export default {
        props: {
            title: {
                type: String,
                default: '',
            },
            type: {
                type: String,
                default: '',
            },
            description: {
                type: String,
                default: null,
            },
            color: {
                type: String,
                default: null,
            },
            hasIndicator: {
                type: Boolean,
                default: true,
            },
            selected: {
                type: Boolean,
                default: false,
            },
            tourClass: String,
        },
        computed: {
            ...mapGetters({
                selectedStep: 'selectedStep',
                selectedColorHex: 'selectedColorHex',
            }),
        },
    };
</script>
